'use client';

import React, { useState } from 'react';

const TutorsPage: React.FC = () => {
  const [modalImage, setModalImage] = useState<{ src: string; alt: string } | null>(null);

  const tutors = [
  {
    name: 'Bailey Cox',
    role: 'FOUNDER & HUMANITIES TUTOR',
    bio: '15 years of experience; specializes in English, Social Studies, and Psychology for all ages.',
    tags: ['English', 'Social Studies', 'Psychology', 'K–12', 'Adult'],
    stars: '★★★★★',
    bgColor: '#f5ede8',
    image: "/assets/images/Bailey_Tutor_Card-1778901021093.png",
    alt: 'Bailey Cox, founder and humanities tutor, smiling professional woman'
  },
  {
    name: 'Sarah',
    role: 'MATH & SCIENCE TUTOR',
    bio: 'B.Sc. in Math & Biology with 3 years tutoring experience. Specializes in grades 7+ math and science.',
    tags: ['Math', 'Science', 'Biology', 'Grades 7+'],
    stars: '★★★★★',
    bgColor: '#e8f0f5',
    image: "/assets/images/Sarah_Tutor_Card-1778901020821.png",
    alt: 'Sarah, math and science tutor, smiling young woman'
  },
  {
    name: 'Graham Mandryk',
    role: 'MATH & SCIENCE TUTOR',
    bio: 'B.Sc. in Conservation Biology, first-aid certified, with 4 years of tutoring experience across a variety of subjects and all ages. Experienced working with students with ADHD, autism, dyslexia, and students who are behind.',
    tags: ['Biology', 'Chemistry', 'Physics', 'Math'],
    stars: '★★★★★',
    bgColor: '#edf5e8',
    image: "/assets/images/Graham_tutor_card-1784685327903.png",
    alt: 'Graham Mandryk, math and science tutor'
  }];


  return (
    <section
      style={{
        padding: '5rem 1.25rem',
        maxWidth: 1200,
        margin: '0 auto',
        position: 'relative',
        zIndex: 1
      }}>
      
      <div className="section-label">Our Team</div>
      <h2 className="section-title" style={{ fontFamily: "'Playfair Display', serif" }}>
        Meet Our Tutors
      </h2>
      <div className="gold-line" />
      <p style={{ color: 'rgba(255,255,255,0.65)', lineHeight: 1.7, maxWidth: 560, marginBottom: '3rem' }}>
        Every tutor is degree-qualified, background-checked, and passionate about helping students succeed.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '2rem', maxWidth: 700, width: '100%' }}>
        {tutors.map((tutor) =>
        <div
          key={tutor.name}
          className="tutor-card"
          style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: 20,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'row',
            transition: 'all 0.3s'
          }}>
          
            {/* Avatar — clickable to open modal */}
            <div
            className="tutor-avatar"
            onClick={() => tutor.image && setModalImage({ src: tutor.image, alt: tutor.alt })}
            style={{
              width: 180,
              minWidth: 180,
              background: tutor.bgColor,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '20px 0 0 20px',
              overflow: 'hidden',
              alignSelf: 'stretch',
              cursor: tutor.image ? 'zoom-in' : 'default',
              position: 'relative'
            }}>
            
              {tutor.image ? (
                <>
                  <img
                    src={tutor.image}
                    alt={tutor.alt}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      objectPosition: 'top',
                      display: 'block'
                    }}
                  />
                  {/* Zoom hint overlay */}
                  <div className="zoom-hint" style={{
                    position: 'absolute',
                    bottom: 8,
                    right: 8,
                    background: 'rgba(0,0,0,0.55)',
                    borderRadius: 6,
                    padding: '3px 7px',
                    fontSize: '0.7rem',
                    color: '#fff',
                    pointerEvents: 'none',
                    opacity: 0,
                    transition: 'opacity 0.2s'
                  }}>
                    🔍 View
                  </div>
                </>
              ) : (
                <div style={{
                  width: '100%',
                  height: '100%',
                  minHeight: 180,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.5rem'
                }}>
                  <div style={{
                    width: 72,
                    height: 72,
                    borderRadius: '50%',
                    background: 'rgba(0,0,0,0.12)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.6rem',
                    fontWeight: 700,
                    color: '#4a7c59',
                    fontFamily: "'Playfair Display', serif"
                  }}>
                    GM
                  </div>
                </div>
              )}
            
            </div>

            {/* Info */}
            <div style={{ padding: '1.5rem', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.25rem', marginBottom: '0.3rem', color: '#fff' }}>
                {tutor.name}
              </h3>
              <div style={{ fontSize: '0.82rem', color: '#f4c430', fontWeight: 600, letterSpacing: '0.05em', marginBottom: '0.8rem' }}>
                {tutor.role}
              </div>
              <div style={{ color: '#f4c430', fontSize: '0.85rem', marginBottom: '0.4rem' }}>{tutor.stars}</div>
              <p style={{ fontSize: '0.88rem', color: 'rgba(255,255,255,0.6)', lineHeight: 1.65, marginBottom: '1.2rem' }}>
                {tutor.bio}
              </p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                {tutor.tags.map((tag) =>
              <span
                key={tag}
                style={{
                  background: 'rgba(244,196,48,0.1)',
                  border: '1px solid rgba(244,196,48,0.2)',
                  color: '#fdd96a',
                  fontSize: '0.75rem',
                  fontWeight: 500,
                  padding: '0.25rem 0.7rem',
                  borderRadius: 6
                }}>
                
                    {tag}
                  </span>
              )}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Lightbox Modal */}
      {modalImage && (
        <div
          onClick={() => setModalImage(null)}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            background: 'rgba(0,0,0,0.88)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1.5rem',
            cursor: 'zoom-out'
          }}>
          {/* Close button */}
          <button
            onClick={() => setModalImage(null)}
            style={{
              position: 'absolute',
              top: 20,
              right: 24,
              background: 'rgba(255,255,255,0.12)',
              border: '1px solid rgba(255,255,255,0.25)',
              borderRadius: '50%',
              width: 44,
              height: 44,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              color: '#fff',
              fontSize: '1.4rem',
              lineHeight: 1,
              transition: 'background 0.2s'
            }}
            aria-label="Close image"
          >
            ×
          </button>
          {/* Image */}
          <img
            src={modalImage.src}
            alt={modalImage.alt}
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: '90vw',
              maxHeight: '90vh',
              objectFit: 'contain',
              borderRadius: 12,
              boxShadow: '0 8px 48px rgba(0,0,0,0.6)',
              cursor: 'default'
            }}
          />
        </div>
      )}

      <style>{`
        .tutor-avatar:hover .zoom-hint {
          opacity: 1 !important;
        }
        @media (max-width: 640px) {
          .tutor-card {
            flex-direction: column !important;
            min-height: unset !important;
          }
          .tutor-avatar {
            width: 100% !important;
            min-width: unset !important;
            height: auto !important;
            border-radius: 20px 20px 0 0 !important;
            align-self: auto !important;
          }
          .tutor-avatar img {
            width: 100% !important;
            height: auto !important;
            object-fit: contain !important;
            object-position: top !important;
          }
          .tutor-card > div:last-child {
            padding: 1.25rem !important;
          }
        }
      `}</style>
    </section>);

};

export default TutorsPage;